module.exports = __webpack_public_path__ + "montserrat-v14-cyrillic_latin-500.woff2?b4c1a1dc7f990c3b92ae0ad6b180bbf8";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/montserrat-v14-cyrillic_latin-500.woff2
// module id = 16
// module chunks = 0